import styled, { css } from 'styled-components';

const BackgroundOne = styled.div`
  ${({ theme }) => theme.name === 'default' ? css`
    position: absolute;
    top: -10vh;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 70;
  ` : css`
      display: none;
    `}
`;
const BackgroundTwo = styled.div`
  ${({ theme }) => theme.name === 'default' ? css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 60;
  ` : css`display: none;`}
`;
const BackgroundThree = styled.div`
  ${({ theme }) => theme.name === 'default' ? css`
    position: absolute;
    top: 10vh;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 50;
  ` : css`display: none;`}
`;

export { BackgroundOne, BackgroundTwo, BackgroundThree }
